import React from "react"
import {Router} from "@reach/router"
import "./App.css";
import "firebase/auth";
import HomeRouter from "./app/router";

export default function App() {
    return (
        <Router>
            <HomeRouter path={"/*"} />
        </Router>
    )
}
